import { render, staticRenderFns } from "./newmission.vue?vue&type=template&id=5d824066&scoped=true"
import script from "./newmission.vue?vue&type=script&lang=js"
export * from "./newmission.vue?vue&type=script&lang=js"
import style0 from "./newmission.vue?vue&type=style&index=0&id=5d824066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d824066",
  null
  
)

export default component.exports